import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ontos-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ontos_computed_input = _resolveComponent("ontos-computed-input")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_markdown_editor = _resolveComponent("markdown-editor")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              label: _ctx.$tt('workspace-name'),
              class: "required",
              "model-value": _ctx.value.title,
              "error-messages": _ctx.errorMessages.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => {_ctx.onInput('title', $event); _ctx.validateName($event)}),
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateName()))
            }, null, 8, ["label", "model-value", "error-messages"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ontos_computed_input, {
              label: _ctx.$tt('alias'),
              class: "required unique ontos-code",
              value: _ctx.value.alias,
              onInput: _cache[2] || (_cache[2] = ($event: any) => {_ctx.onInput('alias', $event); _ctx.validateAlias($event)}),
              onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateAlias())),
              readonly: _ctx.fixedAlias,
              manual: _ctx.manualAlias,
              "onInput:manual": _cache[4] || (_cache[4] = ($event: any) => (_ctx.manualAlias = $event)),
              source: _ctx.value.title,
              compute: _ctx.$utils.aliasSuggestion,
              computeOnInput: _ctx.$utils.incompleteAliasSuggestion,
              "error-messages": _ctx.errorMessages.alias
            }, null, 8, ["label", "value", "readonly", "manual", "source", "compute", "computeOnInput", "error-messages"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_autocomplete, {
              label: _ctx.$tt('time-zone'),
              items: _ctx.timeZones,
              "model-value": _ctx.value.timeZone,
              hint: _ctx.$tt('time-zone-hint'),
              "persistent-hint": "",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.onInput('timeZone', $event)))
            }, null, 8, ["label", "items", "model-value", "hint"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$tt('workspace-description')), 1),
            _createVNode(_component_markdown_editor, {
              ref: "description",
              initialEditType: "wysiwyg",
              mentions: "",
              item: _ctx.value,
              onChange: _ctx.onDescription,
              onShowMessage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('showMessage', $event)))
            }, null, 8, ["item", "onChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}